import { User, UserRole } from "@joonapp/web-shared"

import { analyticsUserDidLogin } from "../../util/analytics"
import { createJoonAPIClient } from "../../util/joon-api"

export async function loadUser() {
  const API = createJoonAPIClient()
  const { data: user } = await API.get<User>("api/users/me", {
    params: { update_last_login: true },
  })
  analyticsUserDidLogin(user.id.toString())
  return user
}

export const getSBCredentials = async (userId: number) => {
  const API = createJoonAPIClient()
  return API.get<{ sendbird_user_id: string; sendbird_access_token: string }>(
    `api/users/${userId}/sendbird-access-token/`,
    {
      params: { role: "coach" },
    }
  ).then((response) => response.data)
}

export const saveProfileInfo = ({
  userId,
  profileInfo,
}: {
  userId: number
  profileInfo: {
    name: string
    last_name: string
    nickname: string
  }
}) => {
  const { name, last_name, nickname } = profileInfo
  const API = createJoonAPIClient()
  // trackAnalyticEvent(ANALYTIC_EVENTS.settings_save_personal)
  return Promise.all([
    API.patch(`api/users/${userId}/`, { name, last_name }),
    API.post(`api/users/${userId}/update-profile/`, {
      nickname,
      role: UserRole.COACH,
    }),
  ])
}

export const getUserSMSStatus = async (userId: number) => {
  const API = createJoonAPIClient()
  const response = await API.get(
    `api/users/${userId}/notification-preferences/`
  )
  return response.data.coach_message_to_sms
}

export const toggleUserSMSStatus = async ({
  userId,
  status,
}: {
  userId: number
  status: boolean
}) => {
  const API = createJoonAPIClient()
  return API.patch(`api/users/${userId}/notification-preferences/`, {
    coach_message_to_sms: status,
  })
}
